import { axios } from "~/plugins/request";
export const state = () => {
  return {
    messageCount: 0
  };
};
export const mutations = {
  SET_MESSAGE_COUNT: (state, data) => {
    state.messageCount = data;
  }
};
export const actions = {
  getMyPushList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`stationNotification/getMyPushList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  savePushMessage({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`stationNotification/savePushMessage`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getMessageInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`stationNotification/getMessageInfo`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findOrgTreeByCurrentUser({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`stationNotification/findOrgTreeByCurrentUser`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getMyReceiveList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`stationNotification/getMyReceiveList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getReadStatusList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`stationNotification/getReadStatusList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  changeReadStatus({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`stationNotification/changeReadStatus`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getNoReadList({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`stationNotification/getNoReadList`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getMissionSituation({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`stationNotification/getMissionSituation`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  withdrawMessage({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`stationNotification/withdrawMessage`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getOrderNotification({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`stationNotification/getOrderNotification`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getOrderNotification({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`stationNotification/getOrderNotification`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteMyReleaseMessage({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`stationNotification/deleteMyReleaseMessage`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteMyOrderMessage({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`stationNotification/deleteMyOrderMessage`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
